import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'millisecondsToTime'
})
export class MillisecondsToTimePipe implements PipeTransform {
  transform(ms: number | null | undefined): string {
    if (ms === null || ms === undefined || isNaN(ms)) {
      return '00:00';
    }

    const totalMinutes = Math.floor(ms / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

}
